import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomePageComponent } from './containers/home-page/home-page.component';
import { FeaturedDisplayComponent } from './components/featured-display/featured-display.component';
import { FeaturedCardComponent } from './components/featured-card/featured-card.component';
import { SharedModule } from '@src/app/shared/shared/shared.module';
import { GameDisplayComponent } from './components/game-display/game-display.component';
import { GameCardComponent } from './components/game-card/game-card.component';
import { AppDisplayComponent } from './components/app-display/app-display.component';
import { AppCardComponent } from './components/app-card/app-card.component';

@NgModule({
  declarations: [
    HomePageComponent,
    FeaturedDisplayComponent,
    FeaturedCardComponent,
    GameDisplayComponent,
    GameCardComponent,
    AppDisplayComponent,
    AppCardComponent
  ],
  imports: [
    CommonModule,
    SharedModule
  ]
})
export class HomeModule { }
